import React from 'react';

const Loader = ({ style = {} }) => {
    return (
        <>
            <div className="spinner-border" style={{ color: '#072333' }} role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </>
    );
};

export default Loader;
